import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-crema text-bordo pt-16 pb-20 px-4 md:px-8 overflow-hidden" data-id="element-61">
      <div className="max-w-4xl mx-auto text-center" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-63">
          <h1 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-64">
            Soluciona tus comidas de la semana
            <br data-id="element-65" />
            <span className="text-bordo-light" data-id="element-66">con esta guía</span>
          </h1>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="my-12 flex justify-center cursor-pointer" onClick={() => document.getElementById('checkout')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-67">
            <img src="https://cdn.magicpatterns.com/uploads/p84DxRJ8h8jJ4vJCr4drQM/ChatGPT_Image_Apr_30__2026__05_47_03_PM-removebg-preview.png" alt="La Biblia de la Milanesa - Producto completo" className="w-[80%] max-w-2xl h-auto drop-shadow-2xl" data-id="element-68" />
          </motion.div>

          <div className="space-y-4 text-lg md:text-xl mb-12 font-medium text-gray-800" data-id="element-69">
            <p className="text-xl md:text-2xl font-serif font-bold text-bordo-light mt-6" data-id="element-70">
              Una comida que podría ser increíble termina siendo apenas "lo de
              siempre".
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-12" data-id="element-71">
          <CTAButton data-id="element-72" />
        </motion.div>
      </div>
    </section>;
}